import React from 'react';

import FinancialTransactionDetails from './modals/financialTransactionDetails';
import FinancialTransactionListItem from './ListItem';

import generateClassName from '../../utils/generateClassName';

class FinancialTransactionsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortType: 'asc',
      sortName: 'createdDate',
      detailsIsOpen: false,
      selectedItemId: null,
      sortedColumn: ''
    };
  }

  sortTable = query => {
    this.props.sortTable(query);
    this.setState(() => ({ sortedColumn: query }));
  };

  displayDetailsModal = id => {
    const selectedItem = this.props.financialTransactionsList.find(
      x => x.id == id
    );

    this.setState(() => ({
      detailsIsOpen: true,
      selectedItemId: selectedItem.id
    }));
  };

  // financial transaction modal
  closeDetailsModal = () => {
    this.setState(() => ({
      detailsIsOpen: false
    }));
  };

  // link to user
  routeToEditUser = (event, userId) => {
    event.preventDefault();

    return this.props.history.push({
      pathname: '/users/edit',
      state: { id: userId }
    });
  };

  render() {
    let { financialTransactionsList, pageNumber, pageSize, sortType } = this.props;

    return (
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th onClick={() => this.sortTable('userFullName')} className="text-center pointer">
                <i
                  name="userFullName"
                  className={generateClassName('name', this.state.sortedColumn, sortType)}
                />
                {locales('tables.financial.transaction.userFullName')}
              </th>
              <th onClick={() => this.sortTable('userMobileNumber')} className="text-center pointer">
                <i
                  name="userMobileNumber"
                  className={generateClassName('name', this.state.sortedColumn, sortType)}
                />
                {locales('tables.financial.transaction.userMobileNumber')}
              </th>
              <th onClick={() => this.sortTable('trackingNumber')} className="text-center pointer">
                <i
                  name="trackingNumber"
                  className={generateClassName('name', this.state.sortedColumn, sortType)}
                />
                {locales('tables.trackingCodeReserve')}
              </th>
              <th onClick={() => this.sortTable('type')} className="text-center pointer">
                <i name="type" className={generateClassName('name', this.state.sortedColumn, sortType)} />
                {locales('tables.financial.transaction.type')}
              </th>
              <th onClick={() => this.sortTable('amount')} className="text-center pointer">
                <i name="amount" className={generateClassName('name', this.state.sortedColumn, sortType)} />
                {locales('tables.financial.transaction.amount')}
              </th>
              <th onClick={() => this.sortTable('remainingCredit')} className="text-center pointer">
                <i
                  name="remainingCredit"
                  className={generateClassName('name', this.state.sortedColumn, sortType)}
                />
                {locales('tables.financial.transaction.remainingCredit')}
              </th>
              <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
                <i
                  name="createdAt"
                  className={generateClassName('name', this.state.sortedColumn, sortType)}
                />
                {locales('tables.financial.transaction.createdDate')}
              </th>
              <th className="text-center">{locales('tables.financial.transaction.createdTime')}</th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            {financialTransactionsList && financialTransactionsList.length ? (
              financialTransactionsList.map((financialTransaction, index) => (
                <FinancialTransactionListItem
                  key={financialTransaction.id}
                  id={financialTransaction.id}
                  pageNumber={pageNumber}
                  pageSize={pageSize}
                  index={index}
                  userId={financialTransaction.userId}
                  userFullName={financialTransaction.userFullName}
                  userMobileNumber={financialTransaction.userMobileNumber}
                  trackingNumber={financialTransaction.trackingNumber}
                  type={financialTransaction.type}
                  amount={financialTransaction.amount}
                  remainingCredit={financialTransaction.remainingCredit}
                  createdDate={financialTransaction.createdDate}
                  createdTime={financialTransaction.createdTime}

                  displayDetailsModal={this.displayDetailsModal}
                />
              ))
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {this.state.detailsIsOpen && (
          <FinancialTransactionDetails
            isOpen={this.state.detailsIsOpen}
            financialTransactionId={this.state.selectedItemId}
            closeModal={this.closeDetailsModal}
          />
        )}
      </div>
    );
  }
}

export default FinancialTransactionsTable;
